import { Button } from '@factorialco/deprecated-design-system'
import { DeleteSalesDocumentTemplateDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { SalesDocumentTemplateLoadingModal } from 'modules/finance/activities/salesDocumentTemplate/components/SalesDocumentTemplateLoadingModal'
import { SalesDocumentTemplateNotFoundModal } from 'modules/finance/activities/salesDocumentTemplate/components/SalesDocumentTemplateNotFoundModal'
import { useSalesDocumentTemplate } from 'modules/finance/activities/salesDocumentTemplate/useSalesDocumentTemplate'

export const SalesDocumentTemplateDeleteModal = ({
  isOpen,
  onClose,
  refetchQuery,
  salesDocumentTemplateId,
}: {
  isOpen: boolean
  onClose: () => void
  refetchQuery?: string
  salesDocumentTemplateId: string
}) => {
  const { salesDocumentTemplate, loading, notFound } = useSalesDocumentTemplate(
    salesDocumentTemplateId,
    isOpen
  )

  const [deleteSalesDocumentTemplate, { loading: deleting }] = useMutation(
    DeleteSalesDocumentTemplateDocument,
    {
      extractorFn: (data) => data.financeMutations.deleteFinanceSalesDocumentTemplate,
      refetchQueries: refetchQuery ? [refetchQuery] : undefined,
    }
  )

  const onSubmit = async () => {
    const result = await deleteSalesDocumentTemplate({
      variables: {
        id: salesDocumentTemplateId,
      },
    })

    const handled = handleResult(result, (parsedErrors) => {
      app.setFlash({
        type: 'wrong',
        message: parsedErrors.errors ?? i18n.t('errors.generic_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.sales_document_templates.modal.delete_success'),
        time: 2000,
      })
      onClose()
    }
  }

  if (!isOpen || (!salesDocumentTemplate && !loading)) return null

  if (loading) {
    return (
      <SalesDocumentTemplateLoadingModal
        title={i18n.t('finance.sales_document_templates.modal.delete_template.title')}
        onClose={onClose}
      />
    )
  }

  if (notFound) {
    return (
      <SalesDocumentTemplateNotFoundModal
        title={i18n.t('finance.sales_document_templates.modal.delete_template.title')}
        salesDocumentTemplateId={salesDocumentTemplateId}
        onClose={onClose}
      />
    )
  }

  return (
    <Modal
      illustration="template"
      title={i18n.t('finance.sales_document_templates.modal.delete_template.title', {
        name: salesDocumentTemplate?.name ?? '',
      })}
      description={i18n.t('finance.sales_document_templates.modal.delete_template.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={deleting}>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    />
  )
}
